module.exports = __webpack_public_path__ + "static/media/20-8.3d15b376.mp3";